import * as React from 'react';
import { cn } from './utils';

/** Loading placeholder; the pulse collapses under prefers-reduced-motion. */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('animate-pulse rounded-ctl bg-border-2', className)}
      {...props}
    />
  );
}

export { Skeleton };
